module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_mitochondrion_cellular_respiration_6-29601e1158202dc811a82a497669d69c.jpg";